"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePolicy = resolvePolicy;
const v1_1 = require("./policies/v1");
const policies = {
    v1: v1_1.CalculationPolicyV1,
};
/**
 * Maps calculation_policy_version.version_label -> concrete policy implementation.
 * Old work_line rows keep referencing their original calculation_policy_version_id
 * and are NEVER retroactively recomputed under a newer policy — only new entries
 * created after a new version's effective_from use it (CALCULATION_ENGINE_ARCHITECTURE.md §3).
 */
function resolvePolicy(versionLabel) {
    const policy = policies[versionLabel];
    if (!policy) {
        throw new Error(`Unknown calculation policy version: ${versionLabel}`);
    }
    return policy;
}
//# sourceMappingURL=registry.js.map